export const CREATE_OTHER_ALLOWANCE = "CREATE_OTHER_ALLOWANCE";
export const FETCH_OTHER_ALLOWANCES = "FETCH_OTHER_ALLOWANCES";
export const FETCH_OTHER_ALLOWANCE = "FETCH_OTHER_ALLOWANCE";
export const EDIT_OTHER_ALLOWANCE = "EDIT_OTHER_ALLOWANCE";
export const DELETE_OTHER_ALLOWANCE = "DELETE_OTHER_ALLOWANCE";
export const CLEAR_OTHER_ALLOWANCE = "CLEAR_OTHER_ALLOWANCE";
